import script from "./NumberSettingsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NumberSettingsDialog.vue?vue&type=script&setup=true&lang=js"

import "./NumberSettingsDialog.vue?vue&type=style&index=0&id=2a97a136&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a97a136"]])

export default __exports__